import React from "react";
import "./Phonetic.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faVolumeHigh } from "@fortawesome/free-solid-svg-icons";


export default function Phonetic(props) {
  const speak = () => {
    const utterance = new SpeechSynthesisUtterance(props.word);
    utterance.lang = "en-US";
    speechSynthesis.speak(utterance);
  };

  return (
    <div>
      <button onClick={speak}>
        <FontAwesomeIcon icon={faVolumeHigh} />
      </button>
      <span>  /{props.phonetic}/</span>
    </div>
  );
}